﻿define('SageDotCom/Components/CallButton',['jquery', 'SageDotCom/DataLayer/tealium', 'SageDotCom/DataLayer/Events/contactus'], function($, tealium, contactUsEvent) {
    function CallButton(scope, number) {
        tealium.registerPageData({ 'page_phone_number': number });

        $("img, span", scope).on("click", function(){
            var data = contactUsEvent.GenerateEventMetadata(event.currentTarget, $(".telephone-text", scope).text());
            tealium.event(data);
        });
    }

    return function init(args) {
        return args.IsExperienceEditorEditing ? null : new CallButton(args.scope, args.Phone);
    }
});
